import styled from 'styled-components';

export const ResultPreviewWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    cursor: pointer;
    border-radius: 4px;
    padding: 8px;
    position: relative;
    left: -8px;
    background: ${theme.colors.cardElevationLowWhite};

    p {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    }

    &:hover, &:focus-visible {
        background: ${theme.colors.cardInteractionHoverGrey05};
        p {
            color: ${theme.colors.textPrimarySecondary1100};
        }
    }

    &:focus-visible {
        outline: 3px solid ${theme.colors.chartChartLightbluePressedSecondary240};
    }

    &:active {
        background: ${theme.colors.cardInteractionActiveSecondary420};
        p {
            color: ${theme.colors.textPrimarySecondary1100};
        }
    }
`}
`;

export const SearchResultDivider = styled.div`
  height: 0px;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.colors.backgroundInteractionActiveGrey20};
`;

export const SearchResultsWrapper = styled.div`
  max-width: 536px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.small}) {
    margin-top: -12px;
  }
`;
